<template>
    <div>
        <SearchBox ref="SearchBox">
            <el-form slot="form" :inline="true" ref="searchData" :model="searchParams" label-width="80px" class="unitWidth" size="small">
                <el-form-item label="所属工厂">
                    <el-select v-model="fcIdSelected" placeholder="请选择" clearable filterable @change="fcChange">
                        <el-option v-for="factory in factoryList" :key="factory.value" :label="factory.label" :value="factory.value" />
                    </el-select>
                </el-form-item>
                <el-form-item label="所属车间">
                    <el-select v-model="shopSelected" placeholder="请选择" clearable filterable @change="shopChange">
                        <el-option v-for="shop in shopList" :key="shop.value" :label="shop.label" :value="shop.value" />
                    </el-select>
                </el-form-item>
                <el-form-item label="所属工段">
                    <el-select v-model="sectionSelected" placeholder="请选择" clearable filterable @change="sectionChange">
                        <el-option v-for="section in sectionList" :key="section.value" :label="section.label" :value="section.value" />
                    </el-select>
                </el-form-item>
                <el-form-item label="所属产线">
                    <el-select v-model="lineSelected" placeholder="请选择" clearable filterable @change="lineChange">
                        <el-option v-for="line in lineList" :key="line.value" :label="line.label" :value="line.value" />
                    </el-select>
                </el-form-item>
                <el-form-item label="名称">
                    <el-input v-model="searchRestName" placeholder="请输入" clearable />
                </el-form-item>
                <el-form-item>
                    <el-button type="primary" @click="searchTable">查询</el-button>
                    <el-button type="success" @click="showAddDialog">新增</el-button>
                </el-form-item>
            </el-form>
        </SearchBox>
        <LabelContent title="吃饭休息配置列表" ref="LabelContent">
            <div slot="btns">
                <el-button size="small" type="danger" @click="showBatchCancelDialog">批量取消</el-button>
                <el-button size="small" type="info" @click="downloadTemplate">下载模板</el-button>
                <el-upload action="" :http-request="handleImport" :show-file-list="false" accept=".xls,.xlsx" style="display:inline-block;margin-left:8px;">
                    <el-button size="small" type="warning">批量导入</el-button>
                </el-upload>
            </div>
        </LabelContent>
        <div class="tableBox">
            <el-table stripe ref="multipleTable" :data="tableData" class="center" v-loading="loading">
                <el-table-column prop="restName" label="配置名称" show-overflow-tooltip />
                <el-table-column prop="haltType" label="类型" show-overflow-tooltip>
                    <template slot-scope="scope">{{ haltTypeMap[scope.row.haltType] || scope.row.haltType || '-' }}</template>
                </el-table-column>
                <el-table-column prop="startTime" label="开始时间" show-overflow-tooltip />
                <el-table-column prop="endTime" label="结束时间" show-overflow-tooltip />
                <el-table-column prop="durationMinutes" label="时长(分)" width="80" show-overflow-tooltip />
                <el-table-column prop="remark" label="备注" show-overflow-tooltip />
                <el-table-column prop="fcCode" label="工厂" show-overflow-tooltip />
                <el-table-column prop="shopCode" label="车间" show-overflow-tooltip />
                <el-table-column prop="sectionCode" label="工段" show-overflow-tooltip />
                <el-table-column prop="lineCode" label="产线" show-overflow-tooltip />
                <el-table-column prop="createUser" label="创建人" width="100" show-overflow-tooltip />
                <el-table-column prop="isActive" label="状态">
                    <template slot-scope="scope">
                        <el-tag :type="scope.row.isActive ? 'success' : 'danger'" size="small">{{ scope.row.isActive ? '启用' : '禁用' }}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column prop="isCancelled" label="今日">
                    <template slot-scope="scope">
                        <el-tag :type="scope.row.isCancelled ? 'warning' : 'info'" size="small">{{ scope.row.isCancelled ? '取消' : '正常' }}</el-tag>
                    </template>
                </el-table-column>
                <el-table-column label="操作" width="150">
                    <template slot-scope="scope">
                        <div style="display:flex;gap:6px;margin-bottom:4px;">
                            <el-button size="mini" type="primary" @click="showEditDialog(scope.row)">编辑</el-button>
                            <el-button size="mini" :type="scope.row.isActive ? 'warning' : 'success'" @click="toggleActive(scope.row)">{{ scope.row.isActive ? '禁用' : '启用' }}</el-button>
                        </div>
                        <div style="display:flex;gap:6px;">
                            <el-button size="mini" type="danger" @click="delConfig(scope.row)">删除</el-button>
                            <el-button size="mini" style="background:#f78914;border-color:#f78914;color:#fff;" v-if="!scope.row.isCancelled && scope.row.restType === 'changeover'" @click="manualTrigger(scope.row)">启动</el-button>
                            <el-button size="mini" style="background:#f78914;border-color:#f78914;color:#fff;" v-if="!scope.row.isCancelled && scope.row.restType !== 'changeover'" @click="cancelToday(scope.row)">取消当天</el-button>
                            <el-button size="mini" type="info" @click="showCancelDateDialog(scope.row)">取消日期</el-button>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
        <el-pagination @size-change="handleSizeChange" @current-change="handleCurrentChange" :current-page="pageNum" :page-sizes="[10, 20, 50]" :page-size="pageSize" layout="total, sizes, prev, pager, next" :total="total" style="margin-top:15px;text-align:right;" />

        <!-- 新增/编辑弹窗 -->
        <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="500px" :close-on-click-modal="false">
            <el-form label-width="80px" size="small">
                <el-form-item label="配置名称">
                    <el-select v-model="formData.restName" allow-create filterable placeholder="请选择或输入名称" style="width:100%">
                        <el-option v-for="item in restNameOptions" :key="item" :label="item" :value="item" />
                    </el-select>
                </el-form-item>
                <el-form-item label="类型">
                    <el-select v-model="formData.haltType" placeholder="请选择类型" filterable>
                        <el-option v-for="item in haltTypeOptions" :key="item.value" :label="item.label" :value="item.value" />
                    </el-select>
                </el-form-item>
                <el-form-item label="开始时间" v-if="formData.haltType !== 'M3'">
                    <el-time-picker v-model="formData.startTime" value-format="HH:mm" format="HH:mm" placeholder="选择开始时间" style="width:100%" />
                </el-form-item>
                <el-form-item label="结束时间" v-if="formData.haltType !== 'M3'">
                    <el-time-picker v-model="formData.endTime" value-format="HH:mm" format="HH:mm" placeholder="选择结束时间" style="width:100%" />
                </el-form-item>
                <el-form-item label="标准时长" v-if="formData.haltType === 'M3'">
                    <el-input v-model.number="formData.durationMinutes" placeholder="请输入分钟数" style="width:100%">
                        <template slot="append">分钟</template>
                    </el-input>
                </el-form-item>
                <el-form-item label="备注">
                    <el-input v-model="formData.remark" placeholder="选填备注信息" />
                </el-form-item>
                <el-form-item label="工厂">
                    <el-select v-model="fcIdSelectedForm" filterable placeholder="请选择工厂" @change="fcChangeForm">
                        <el-option v-for="factory in factoryList" :key="factory.value" :label="factory.label" :value="factory.value" />
                    </el-select>
                </el-form-item>
                <el-form-item label="车间">
                    <el-select v-model="shopSelectedForm" clearable filterable placeholder="请选择车间" @change="shopChangeForm">
                        <el-option v-for="shop in shopListForm" :key="shop.value" :label="shop.label" :value="shop.value" />
                    </el-select>
                </el-form-item>
                <el-form-item label="工段">
                    <el-select v-model="sectionSelectedForm" clearable filterable placeholder="请选择工段" @change="sectionChangeForm">
                        <el-option v-for="section in sectionListForm" :key="section.value" :label="section.label" :value="section.value" />
                    </el-select>
                </el-form-item>
                <el-form-item label="产线">
                    <el-select v-model="lineCodesForm" multiple collapse-tags filterable placeholder="可多选产线">
                        <el-option v-for="line in lineListForm" :key="line.value" :label="line.label" :value="line.value" />
                    </el-select>
                </el-form-item>
            </el-form>
            <span slot="footer">
                <el-button @click="dialogVisible = false" size="small">取消</el-button>
                <el-button type="primary" @click="submitForm" size="small" :loading="submitLoading">确定</el-button>
            </span>
        </el-dialog>

        <!-- 取消日期弹窗 -->
        <el-dialog title="取消日期配置" :visible.sync="cancelDateDialogVisible" width="550px" :close-on-click-modal="false">
            <div style="margin-bottom:16px;">
                <el-form :inline="true" size="small">
                    <el-form-item label="单日取消">
                        <el-date-picker v-model="cancelDateSingle" type="date" value-format="yyyy-MM-dd" placeholder="选择日期" style="width:160px" />
                        <el-button type="warning" @click="submitCancelDate" style="margin-left:8px;">确认取消</el-button>
                    </el-form-item>
                </el-form>
                <el-form :inline="true" size="small" style="margin-top:4px;">
                    <el-form-item label="范围取消">
                        <el-date-picker v-model="cancelDateRange" type="daterange" value-format="yyyy-MM-dd" range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" style="width:240px" />
                        <el-button type="warning" @click="submitCancelDateRange" style="margin-left:8px;">确认取消</el-button>
                    </el-form-item>
                </el-form>
            </div>
            <el-divider content-position="left">已取消的日期</el-divider>
            <div v-if="cancelDateList.length === 0" style="color:#999;text-align:center;padding:10px;">暂无取消日期</div>
            <el-tag v-for="item in cancelDateList" :key="item.acdId" closable :disable-transitions="false" @close="removeCancelDate(item.acdId)" style="margin:4px;" type="warning" size="small">{{ item.date }}</el-tag>
            <span slot="footer">
                <el-button @click="cancelDateDialogVisible = false" size="small">关闭</el-button>
            </span>
        </el-dialog>

        <!-- 批量取消产线弹窗 -->
        <el-dialog title="批量取消产线" :visible.sync="batchCancelDialogVisible" width="1200px" :close-on-click-modal="false" top="3vh">
            <div class="batch-cancel-dialog">
                <!-- 取消配置区 -->
                <div class="config-section">
                    <div class="section-title">
                        <i class="el-icon-setting"></i> 取消配置
                    </div>
                    <el-form label-width="70px" size="small" class="config-form">
                        <!-- 第一行：工厂、车间、工段 保持原布局不变 -->
                        <el-row :gutter="20">
                            <el-col :span="8">
                                <el-form-item label="工厂">
                                    <el-select v-model="batchFcSelected" filterable placeholder="请选择工厂" @change="batchFcChange" style="width:100%">
                                        <el-option v-for="f in factoryList" :key="f.value" :label="f.label" :value="f.value" />
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item label="车间">
                                    <el-select v-model="batchShopSelected" clearable filterable placeholder="请选择" @change="batchShopChange" style="width:100%" :disabled="!batchFcSelected">
                                        <el-option v-for="s in batchShopList" :key="s.value" :label="s.label" :value="s.value" />
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <el-form-item label="工段">
                                    <el-select v-model="batchSectionSelected" clearable filterable placeholder="请选择" @change="batchSectionChange" style="width:100%" :disabled="!batchShopSelected">
                                        <el-option v-for="v in batchSectionList" :key="v.value" :label="v.label" :value="v.value" />
                                    </el-select>
                                </el-form-item>
                            </el-col>
                        </el-row>
                        <!-- 第二行：选择产线 + 备注（备注位于车间正下方 span:8 列） -->
                        <el-row :gutter="20">
                            <el-col :span="8">
                                <el-form-item label="选择产线">
                                    <el-select v-model="batchLineCodes" multiple filterable placeholder="可多选产线" style="width:100%" collapse-tags>
                                        <el-option v-for="l in batchLineList" :key="l.value" :label="l.label" :value="l.value" />
                                    </el-select>
                                </el-form-item>
                            </el-col>
                            <el-col :span="1">
                                <el-form-item label="备注">
                                    <el-input v-model="batchRemark" placeholder="取消原因（选填）" style="width:100%" />
                                </el-form-item>
                            </el-col>
                            <el-col :span="8">
                                <!-- 空列占位，保持栅格对齐 -->
                            </el-col>
                        </el-row>
                        <!-- 第三行：取消时段 + 确认取消按钮 -->
                        <el-row :gutter="20">
                            <el-col :span="12">
                                <el-form-item label="取消时段">
                                    <el-date-picker
                                        v-model="batchCancelDateTimeRange"
                                        type="datetimerange"
                                        start-placeholder="开始日期时间"
                                        end-placeholder="结束日期时间"
                                        format="yyyy-MM-dd HH:mm"
                                        value-format="yyyy-MM-dd HH:mm"
                                        range-separator="至"
                                        unlink-panels
                                        style="width:100%">
                                    </el-date-picker>
                                </el-form-item>
                            </el-col>
                            <el-col :span="12">
                                <el-form-item>
                                    <el-button type="danger" @click="submitBatchCancel" :loading="batchCancelLoading" icon="el-icon-close">确认取消</el-button>
                                </el-form-item>
                            </el-col>
                        </el-row>
              
                    </el-form>
                </div>

                <!-- 已取消记录区 -->
                <el-divider />
                <div class="list-section">
                    <div class="section-title">
                        <i class="el-icon-document"></i> 已取消记录
                    </div>
                    <el-form :inline="true" size="small" class="search-form">
                        <el-form-item label="工厂">
                            <el-select v-model="cancelSearchFc" filterable placeholder="全部" clearable @change="cancelSearchFcChange" style="width:150px">
                                <el-option v-for="f in factoryList" :key="f.value" :label="f.label" :value="f.value" />
                            </el-select>
                        </el-form-item>
                        <el-form-item label="车间">
                            <el-select v-model="cancelSearchShop" clearable placeholder="全部" @change="cancelSearchShopChange" style="width:150px" :disabled="!cancelSearchFc">
                                <el-option v-for="s in cancelSearchShopList" :key="s.value" :label="s.label" :value="s.value" />
                            </el-select>
                        </el-form-item>
                        <el-form-item label="工段">
                            <el-select v-model="cancelSearchSection" clearable placeholder="全部" @change="cancelSearchSectionChange" style="width:150px" :disabled="!cancelSearchShop">
                                <el-option v-for="v in cancelSearchSectionList" :key="v.value" :label="v.label" :value="v.value" />
                            </el-select>
                        </el-form-item>
                        <el-form-item label="产线">
                            <el-select v-model="cancelSearchLine" clearable placeholder="全部" style="width:150px" :disabled="!cancelSearchSection">
                                <el-option v-for="l in cancelSearchLineList" :key="l.value" :label="l.label" :value="l.value" />
                            </el-select>
                        </el-form-item>
                        <el-form-item>
                            <el-button type="primary" @click="loadBatchCancelList" icon="el-icon-search">查询</el-button>
                        </el-form-item>
                    </el-form>
                    <el-table :data="batchCancelList" size="small" max-height="400" :header-cell-style="{background:'#f5f7fa'}">
                        <el-table-column prop="fcCode" label="工厂" width="100" />
                        <el-table-column prop="shopCode" label="车间" width="100" />
                        <el-table-column prop="sectionCode" label="工段" width="100" />
                        <el-table-column prop="lineCode" label="产线" width="100" />
                        <el-table-column label="取消时段" width="230">
                            <template slot-scope="scope">
                                <span>{{ formatDate(scope.row.startDate) }} {{ scope.row.startTime }}</span>
                                <span style="margin:0 4px;color:#909399;">~</span>
                                <span>{{ formatDate(scope.row.endDate) }} {{ scope.row.endTime }}</span>
                            </template>
                        </el-table-column>
                        <el-table-column prop="remark" label="备注" min-width="160" show-overflow-tooltip />
                        <el-table-column prop="cancelUserName" label="取消人" width="100" />
                        <el-table-column prop="createTime" label="创建时间" width="160">
                            <template slot-scope="scope">{{ formatDate(scope.row.createTime) }}</template>
                        </el-table-column>
                        <el-table-column label="操作" width="70" align="center" fixed="right">
                            <template slot-scope="scope">
                                <el-button size="mini" type="text" style="color:#f56c6c" @click="deleteLineCancel(scope.row.arlcId)">删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
            <span slot="footer">
                <el-button @click="batchCancelDialogVisible = false" size="small">关闭</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import SearchBox from '@/components/public/searchBox'
import LabelContent from '@/components/public/labelContent'
export default {
    name: 'AndonRestConfig',
    components: { SearchBox, LabelContent },
    data() {
        return {
            loading: false,
            submitLoading: false,
            dialogVisible: false,
            dialogTitle: '',
            isEdit: false,
            pageNum: 1,
            pageSize: 20,
            total: 0,
            tableData: [],
            factoryTree: [],
            searchParams: {},
            searchRestName: '',
            fcIdSelected: '',
            shopSelected: '',
            sectionSelected: '',
            lineSelected: '',
            formData: { restName: '', haltType: 'P5', startTime: '', endTime: '', fcCode: '', shopCode: '', sectionCode: '', lineCodes: [] },
            fcIdSelectedForm: '',
            shopSelectedForm: '',
            sectionSelectedForm: '',
            lineCodesForm: [],
            restTypeMap: { meal: '吃饭', rest: '休息', meeting: '班会', changeover: '换型', trial: '试制', other: '其他' },
            haltTypeMap: { P2: '开班验证', P3: '5S-班会', P4: '员工培训', P5: '用餐及休息', P8: '计划停机', M3: '换型', P9: '试制' },
            haltTypeOptions: [
                { value: 'P2', label: 'P2-开班验证' },
                { value: 'P3', label: 'P3-5S-班会' },
                { value: 'P4', label: 'P4-员工培训' },
                { value: 'P5', label: 'P5-用餐及休息' },
                { value: 'P8', label: 'P8-计划停机' },
                { value: 'M3', label: 'M3-换型' },
                { value: 'P9', label: 'P9-试制' }
            ],
            restNameOptions: ['早餐', '午餐', '晚餐', '夜宵', '中午休息', '下午休息', '晚上休息'],
            cancelDateDialogVisible: false,
            cancelDateArcId: null,
            cancelDateSingle: '',
            cancelDateRange: null,
            cancelDateList: [],
            batchCancelDialogVisible: false,
            batchCancelLoading: false,
            batchFcSelected: '',
            batchShopSelected: '',
            batchSectionSelected: '',
            batchLineCodes: [],
            batchCancelDateTimeRange: null,
            batchRemark: '',
            batchCancelList: [],
            cancelSearchFc: '',
            cancelSearchShop: '',
            cancelSearchSection: '',
            cancelSearchLine: ''
        }
    },
    computed: {
        factoryList() {
            var arr = []
            if (this.factoryTree && this.factoryTree.length > 0) {
                for (var i = 0; i < this.factoryTree.length; i++) {
                    arr.push({ label: this.factoryTree[i].deptName, value: JSON.stringify(this.factoryTree[i]) })
                }
            }
            return arr
        },
        shopList() {
            var arr = []
            if (this.fcIdSelected && this.fcIdSelected.length > 0) {
                var factory = JSON.parse(this.fcIdSelected)
                var shops = factory.child || []
                for (var i = 0; i < shops.length; i++) {
                    arr.push({ label: shops[i].deptName, value: JSON.stringify(shops[i]) })
                }
            }
            return arr
        },
        sectionList() {
            var arr = []
            if (this.shopSelected && this.shopSelected.length > 0) {
                var shop = JSON.parse(this.shopSelected)
                var vsms = shop.child || []
                for (var i = 0; i < vsms.length; i++) {
                    arr.push({ label: vsms[i].deptName, value: JSON.stringify(vsms[i]) })
                }
            }
            return arr
        },
        lineList() {
            var arr = []
            if (this.sectionSelected && this.sectionSelected.length > 0) {
                var vsm = JSON.parse(this.sectionSelected)
                var lines = vsm.child || []
                for (var i = 0; i < lines.length; i++) {
                    arr.push({ label: lines[i].deptName, value: JSON.stringify(lines[i]) })
                }
            }
            return arr
        },
        shopListForm() {
            var arr = []
            if (this.fcIdSelectedForm && this.fcIdSelectedForm.length > 0) {
                var factory = JSON.parse(this.fcIdSelectedForm)
                var shops = factory.child || []
                for (var i = 0; i < shops.length; i++) {
                    arr.push({ label: shops[i].deptName, value: JSON.stringify(shops[i]) })
                }
            }
            return arr
        },
        sectionListForm() {
            var arr = []
            if (this.shopSelectedForm && this.shopSelectedForm.length > 0) {
                var shop = JSON.parse(this.shopSelectedForm)
                var vsms = shop.child || []
                for (var i = 0; i < vsms.length; i++) {
                    arr.push({ label: vsms[i].deptName, value: JSON.stringify(vsms[i]) })
                }
            }
            return arr
        },
        lineListForm() {
            var arr = []
            if (this.sectionSelectedForm && this.sectionSelectedForm.length > 0) {
                var vsm = JSON.parse(this.sectionSelectedForm)
                var lines = vsm.child || []
                for (var i = 0; i < lines.length; i++) {
                    arr.push({ label: lines[i].deptName, value: JSON.stringify(lines[i]) })
                }
            }
            return arr
        },
        batchShopList() {
            var arr = []
            if (this.batchFcSelected && this.batchFcSelected.length > 0) {
                var factory = JSON.parse(this.batchFcSelected)
                var shops = factory.child || []
                for (var i = 0; i < shops.length; i++) {
                    arr.push({ label: shops[i].deptName, value: JSON.stringify(shops[i]) })
                }
            }
            return arr
        },
        batchSectionList() {
            var arr = []
            if (this.batchShopSelected && this.batchShopSelected.length > 0) {
                var shop = JSON.parse(this.batchShopSelected)
                var vsms = shop.child || []
                for (var i = 0; i < vsms.length; i++) {
                    arr.push({ label: vsms[i].deptName, value: JSON.stringify(vsms[i]) })
                }
            }
            return arr
        },
        batchLineList() {
            var arr = []
            if (this.batchSectionSelected && this.batchSectionSelected.length > 0) {
                var vsm = JSON.parse(this.batchSectionSelected)
                var lines = vsm.child || []
                for (var i = 0; i < lines.length; i++) {
                    arr.push({ label: lines[i].deptName, value: lines[i].deptCode })
                }
            }
            return arr
        },
        cancelSearchShopList() {
            var arr = []
            if (this.cancelSearchFc && this.cancelSearchFc.length > 0) {
                var factory = JSON.parse(this.cancelSearchFc)
                var shops = factory.child || []
                for (var i = 0; i < shops.length; i++) {
                    arr.push({ label: shops[i].deptName, value: JSON.stringify(shops[i]) })
                }
            }
            return arr
        },
        cancelSearchSectionList() {
            var arr = []
            if (this.cancelSearchShop && this.cancelSearchShop.length > 0) {
                var shop = JSON.parse(this.cancelSearchShop)
                var vsms = shop.child || []
                for (var i = 0; i < vsms.length; i++) {
                    arr.push({ label: vsms[i].deptName, value: JSON.stringify(vsms[i]) })
                }
            }
            return arr
        },
        cancelSearchLineList() {
            var arr = []
            if (this.cancelSearchSection && this.cancelSearchSection.length > 0) {
                var vsm = JSON.parse(this.cancelSearchSection)
                var lines = vsm.child || []
                for (var i = 0; i < lines.length; i++) {
                    arr.push({ label: lines[i].deptName, value: lines[i].deptCode })
                }
            }
            return arr
        }
    },
    mounted() {
        this.getData()
        this.searchTable()
    },
    methods: {
        getData() {
            this.$http.request({ url: this.$api.departTree, method: 'GET' }).then(resp => {
                if (resp.status === 100) this.factoryTree = resp.data || []
            })
        },
        getDeptCode(jsonVal) {
            if (!jsonVal) return ''
            try { var obj = JSON.parse(jsonVal); return obj.deptCode || '' } catch (e) { return '' }
        },
        fcChange() { this.shopSelected = ''; this.sectionSelected = ''; this.lineSelected = '' },
        shopChange() { this.sectionSelected = ''; this.lineSelected = '' },
        sectionChange() { this.lineSelected = '' },
        lineChange() { },
        fcChangeForm() { this.shopSelectedForm = ''; this.sectionSelectedForm = ''; this.lineCodesForm = [] },
        shopChangeForm() { this.sectionSelectedForm = ''; this.lineCodesForm = [] },
        sectionChangeForm() { this.lineCodesForm = [] },
        searchTable() {
            this.loading = true
            this.$http.request({
                url: this.$api.andonRestConfigPageList,
                method: 'GET',
                params: {
                    pageNum: this.pageNum, pageSize: this.pageSize,
                    fcCode: this.getDeptCode(this.fcIdSelected),
                    shopCode: this.getDeptCode(this.shopSelected),
                    sectionCode: this.getDeptCode(this.sectionSelected),
                    lineCode: this.getDeptCode(this.lineSelected),
                    restName: this.searchRestName
                }
            }).then(resp => {
                this.loading = false
                if (resp.status === 100) {
                    this.tableData = resp.data.list || resp.data.data || []
                    this.total = resp.data.total || 0
                }
            }).catch(() => { this.loading = false })
        },
        handleSizeChange(val) { this.pageSize = val; this.searchTable() },
        handleCurrentChange(val) { this.pageNum = val; this.searchTable() },
        showAddDialog() {
            this.isEdit = false
            this.dialogTitle = '新增配置'
            this.formData = { restName: '', haltType: 'P5', startTime: '', endTime: '', fcCode: '', shopCode: '', sectionCode: '', lineCodes: [] }
            this.fcIdSelectedForm = ''; this.shopSelectedForm = ''; this.sectionSelectedForm = ''; this.lineCodesForm = []
            this.dialogVisible = true
        },
        showEditDialog(row) {
            this.isEdit = true
            this.dialogTitle = '编辑配置'
            this.formData = { ...row, lineCodes: row.lineCode ? [row.lineCode] : [] }
            this.fcIdSelectedForm = ''; this.shopSelectedForm = ''; this.sectionSelectedForm = ''; this.lineCodesForm = []
            this.$nextTick(() => {
                let factory = this.factoryTree.find(f => f.deptCode === row.fcCode)
                if (factory) {
                    this.fcIdSelectedForm = JSON.stringify(factory)
                    if (row.shopCode) {
                        let shop = (factory.child || []).find(s => s.deptCode === row.shopCode)
                        if (shop) {
                            this.shopSelectedForm = JSON.stringify(shop)
                            if (row.sectionCode) {
                                let section = (shop.child || []).find(v => v.deptCode === row.sectionCode)
                                if (section) {
                                    this.sectionSelectedForm = JSON.stringify(section)
                                    if (row.lineCode) {
                                        let line = (section.child || []).find(l => l.deptCode === row.lineCode)
                                        if (line) this.lineCodesForm = [JSON.stringify(line)]
                                    }
                                }
                            }
                        }
                    }
                }
            })
            this.dialogVisible = true
        },
        submitForm() {
            if (!this.formData.restName || !this.formData.restName.trim()) return this.$message.error('请输入配置名称')
            if (!this.formData.haltType) return this.$message.error('请选择类型')
            if (this.formData.haltType === 'M3') {
                if (!this.formData.durationMinutes || this.formData.durationMinutes <= 0) return this.$message.error('请输入标准时长(分钟)')
            } else {
                if (!this.formData.startTime) return this.$message.error('请选择开始时间')
                if (!this.formData.endTime) return this.$message.error('请选择结束时间')
            }
            this.formData.fcCode = this.getDeptCode(this.fcIdSelectedForm)
            this.formData.shopCode = this.getDeptCode(this.shopSelectedForm)
            this.formData.sectionCode = this.getDeptCode(this.sectionSelectedForm)
            this.formData.lineCodes = (this.lineCodesForm || []).map(v => this.getDeptCode(v)).filter(Boolean)
            if (!this.formData.fcCode) return this.$message.error('请选择工厂')
            this.submitLoading = true
            let url = this.isEdit ? this.$api.andonRestConfigEdit : this.$api.andonRestConfigSave
            this.$http.request({ url, method: 'POST', data: this.formData }).then(resp => {
                this.submitLoading = false
                if (resp.status === 100) { this.$message.success(this.isEdit ? '编辑成功' : '新增成功'); this.dialogVisible = false; this.searchTable() }
                else this.$message.error(resp.message)
            }).catch(() => { this.submitLoading = false })
        },
        toggleActive(row) {
            this.$confirm('确定要' + (row.isActive ? '禁用' : '启用') + '该配置吗？', '提示', { type: 'warning' }).then(() => {
                this.$http.request({ url: this.$api.andonRestConfigToggleActive, method: 'POST', params: { arcId: row.arcId, isActive: !row.isActive } }).then(resp => {
                    if (resp.status === 100) { this.$message.success('操作成功'); this.searchTable() }
                    else this.$message.error(resp.message)
                })
            }).catch(() => {})
        },
        cancelToday(row) {
            this.$confirm('确定要取消当天的该配置吗？次日自动恢复。', '提示', { type: 'warning' }).then(() => {
                this.$http.request({ url: this.$api.andonRestConfigCancelToday, method: 'POST', params: { arcId: row.arcId } }).then(resp => {
                    if (resp.status === 100) { this.$message.success('已取消当天配置'); this.searchTable() }
                    else this.$message.error(resp.message)
                })
            }).catch(() => {})
        },
        delConfig(row) {
            this.$confirm('确定要删除该配置吗？', '提示', { type: 'warning' }).then(() => {
                this.$http.request({ url: this.$api.andonRestConfigDel, method: 'POST', params: { arcId: row.arcId } }).then(resp => {
                    if (resp.status === 100) { this.$message.success('删除成功'); this.searchTable() }
                    else this.$message.error(resp.message)
                })
            }).catch(() => {})
        },
        manualTrigger(row) {
            this.$confirm('确定要手动触发换型安灯吗？将持续 ' + row.durationMinutes + ' 分钟后自动结束。', '提示', { type: 'warning' }).then(() => {
                this.$http.request({ url: this.$api.andonRestConfigManualTrigger, method: 'POST', params: { arcId: row.arcId } }).then(resp => {
                    if (resp.status === 100) { this.$message.success('换型安灯已触发：' + resp.data); this.searchTable() }
                    else this.$message.error(resp.message)
                })
            }).catch(() => {})
        },
        downloadTemplate() {
            this.$http.request({ url: this.$api.andonRestConfigTemplate, method: 'POST', responseType: 'blob' }).then(resp => {
                let blob = new Blob([resp], { type: 'application/vnd.ms-excel' })
                let url = window.URL.createObjectURL(blob)
                let a = document.createElement('a'); a.href = url; a.download = '吃饭休息配置导入模板.xls'; a.click()
                window.URL.revokeObjectURL(url)
            }).catch(() => { this.$message.error('下载失败') })
        },
        handleImport(options) {
            let formData = new FormData(); formData.append('file', options.file)
            this.$http.request({
                url: this.$api.andonRestConfigImport,
                method: 'POST',
                data: formData,
                headers: { 'Content-Type': 'multipart/form-data' },
                showLoading: true
            }).then(resp => {
                if (resp.status === 100) { this.$message.success(resp.data || resp.message || '导入成功'); this.searchTable() }
                else this.$message.error(resp.message || '导入失败')
            }).catch(() => { this.$message.error('导入失败') })
        },
        showCancelDateDialog(row) {
            this.cancelDateArcId = row.arcId
            this.cancelDateSingle = ''
            this.cancelDateRange = null
            this.cancelDateDialogVisible = true
            this.loadCancelDates()
        },
        loadCancelDates() {
            this.$http.request({
                url: this.$api.andonRestConfigGetCancelDates,
                method: 'GET',
                params: { arcId: this.cancelDateArcId }
            }).then(resp => {
                if (resp.status === 100) {
                    this.cancelDateList = (resp.data || []).map(po => ({
                        acdId: po.acdId,
                        date: this.formatDate(po.cancelDate)
                    }))
                }
            })
        },
        submitCancelDate() {
            if (!this.cancelDateSingle) return this.$message.error('请选择日期')
            this.$http.request({
                url: this.$api.andonRestConfigCancelDate,
                method: 'POST',
                params: { arcId: this.cancelDateArcId, date: this.cancelDateSingle }
            }).then(resp => {
                if (resp.status === 100) {
                    this.$message.success('已取消 ' + this.cancelDateSingle)
                    this.cancelDateSingle = ''
                    this.loadCancelDates()
                } else {
                    this.$message.error(resp.message || '取消失败')
                }
            })
        },
        submitCancelDateRange() {
            if (!this.cancelDateRange || this.cancelDateRange.length !== 2) return this.$message.error('请选择日期范围')
            this.$http.request({
                url: this.$api.andonRestConfigCancelDateRange,
                method: 'POST',
                params: { arcId: this.cancelDateArcId, startDate: this.cancelDateRange[0], endDate: this.cancelDateRange[1] }
            }).then(resp => {
                if (resp.status === 100) {
                    this.$message.success('已取消 ' + this.cancelDateRange[0] + ' 至 ' + this.cancelDateRange[1])
                    this.cancelDateRange = null
                    this.loadCancelDates()
                } else {
                    this.$message.error(resp.message || '取消失败')
                }
            })
        },
        removeCancelDate(acdId) {
            this.$confirm('确定要恢复该日期的触发吗？', '提示', { type: 'warning' }).then(() => {
                this.$http.request({
                    url: this.$api.andonRestConfigUncancelDate,
                    method: 'POST',
                    params: { acdId: acdId }
                }).then(resp => {
                    if (resp.status === 100) {
                        this.$message.success('已恢复')
                        this.loadCancelDates()
                    } else {
                        this.$message.error(resp.message || '恢复失败')
                    }
                })
            }).catch(() => {})
        },
        formatDate(dateVal) {
            if (!dateVal) return ''
            if (typeof dateVal === 'number') {
                let d = new Date(dateVal)
                return d.getFullYear() + '-' + String(d.getMonth() + 1).padStart(2, '0') + '-' + String(d.getDate()).padStart(2, '0')
            }
            return String(dateVal).substring(0, 10)
        },
        showBatchCancelDialog() {
            this.batchFcSelected = ''
            this.batchShopSelected = ''
            this.batchSectionSelected = ''
            this.batchLineCodes = []
            this.batchCancelDateTimeRange = null
            this.batchRemark = ''
            this.batchCancelList = []
            this.cancelSearchFc = ''
            this.cancelSearchShop = ''
            this.cancelSearchSection = ''
            this.cancelSearchLine = ''
            this.batchCancelDialogVisible = true
            this.loadBatchCancelList()
        },
        batchFcChange() { this.batchShopSelected = ''; this.batchSectionSelected = ''; this.batchLineCodes = [] },
        batchShopChange() { this.batchSectionSelected = ''; this.batchLineCodes = [] },
        batchSectionChange() { this.batchLineCodes = [] },
        cancelSearchFcChange() { this.cancelSearchShop = ''; this.cancelSearchSection = ''; this.cancelSearchLine = '' },
        cancelSearchShopChange() { this.cancelSearchSection = ''; this.cancelSearchLine = '' },
        cancelSearchSectionChange() { this.cancelSearchLine = '' },
        loadBatchCancelList() {
            let fcCode = this.getDeptCode(this.cancelSearchFc)
            let shopCode = this.getDeptCode(this.cancelSearchShop)
            let sectionCode = this.getDeptCode(this.cancelSearchSection)
            let lineCode = this.cancelSearchLine
            this.$http.request({
                url: this.$api.andonRestConfigLineCancelPageList,
                method: 'GET',
                params: { pageNum: 1, pageSize: 100, fcCode: fcCode, shopCode: shopCode, sectionCode: sectionCode, lineCode: lineCode }
            }).then(resp => {
                if (resp.status === 100) {
                    this.batchCancelList = (resp.data && resp.data.list) ? resp.data.list : []
                }
            })
        },
        submitBatchCancel() {
            if (!this.batchLineCodes || this.batchLineCodes.length === 0) return this.$message.error('请选择产线')
            if (!this.batchCancelDateTimeRange || this.batchCancelDateTimeRange.length !== 2) return this.$message.error('请选择取消时段')
            let fcCode = this.getDeptCode(this.batchFcSelected)
            let shopCode = this.getDeptCode(this.batchShopSelected)
            let sectionCode = this.getDeptCode(this.batchSectionSelected)
            let startArr = this.batchCancelDateTimeRange[0].split(' ')
            let endArr = this.batchCancelDateTimeRange[1].split(' ')
            this.batchCancelLoading = true
            this.$http.request({
                url: this.$api.andonRestConfigBatchCancelLines,
                method: 'POST',
                data: {
                    lineCodes: this.batchLineCodes,
                    fcCode: fcCode,
                    shopCode: shopCode,
                    sectionCode: sectionCode,
                    startDate: startArr[0],
                    endDate: endArr[0],
                    startTime: startArr[1],
                    endTime: endArr[1],
                    remark: this.batchRemark
                }
            }).then(resp => {
                this.batchCancelLoading = false
                if (resp.status === 100) {
                    this.$message.success('批量取消成功')
                    this.batchLineCodes = []
                    this.batchCancelDateTimeRange = null
                    this.batchRemark = ''
                    this.loadBatchCancelList()
                } else {
                    this.$message.error(resp.message || '批量取消失败')
                }
            }).catch(() => { this.batchCancelLoading = false })
        },
        deleteLineCancel(arlcId) {
            this.$confirm('确定要删除该取消记录吗？', '提示', { type: 'warning' }).then(() => {
                this.$http.request({
                    url: this.$api.andonRestConfigDeleteLineCancel,
                    method: 'POST',
                    params: { arlcId: arlcId }
                }).then(resp => {
                    if (resp.status === 100) {
                        this.$message.success('已删除')
                        this.loadBatchCancelList()
                    } else {
                        this.$message.error(resp.message || '删除失败')
                    }
                })
            }).catch(() => {})
        }
    }
}
</script>

<style lang="scss" scoped>
.batch-cancel-dialog {
    .remark-item .el-form-item__label {
        width: 60px !important;
    }
    .section-title {
        font-size: 14px;
        font-weight: 600;
        color: #303133;
        margin-bottom: 16px;
        padding-bottom: 8px;
        border-bottom: 2px solid #409eff;
        i { color: #409eff; margin-right: 4px; }
    }
    .config-section {
        .config-form {
            .el-row { margin-bottom: 0; }
            .el-form-item { margin-bottom: 14px; }
        }
    }
    .list-section {
        .search-form {
            background: #f5f7fa;
            padding: 12px 12px 0;
            border-radius: 4px;
            margin-bottom: 12px;
            .el-form-item { margin-bottom: 10px; }
        }
    }
}
</style>